import { Controller } from "@hotwired/stimulus";

// Periodically refreshes the nearest parent turbo-frame.
//
// Usage:
//   <turbo-frame id="stats">
//     <div data-controller="auto-refresh"
//          data-auto-refresh-url-value="/admin/video_metrics"
//          data-auto-refresh-interval-value="5000">
//       ...content...
//     </div>
//   </turbo-frame>
//
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 5000 },
    url: String,
  };

  connect() {
    this.frame = this.element.closest("turbo-frame");
    if (this.frame && this.hasUrlValue) {
      this.startRefreshing();
    }
  }

  disconnect() {
    this.stopRefreshing();
  }

  startRefreshing() {
    this.timer = setInterval(() => {
      this.frame.src = this.urlValue;
      this.frame.reload();
    }, this.intervalValue);
  }

  stopRefreshing() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
